// extracted by css-extract-rspack-plugin
export default {"SwitchBody":"oreYs","SwitchInput":"Q8Fme"};